export const uid = (length = 12) => {
  return Math.random().toString().slice(2, length + 2).padStart(length, '0')
}
